var EdsTestConfig = /** @class */ (function () {
  function EdsTestConfig() {
  }
  return EdsTestConfig;
}());
var EdsTestUtilClass = /** @class */ (function () {
  function EdsTestUtilClass() {
  }

  EdsTestUtilClass.prototype.insertJsSnippetWithSetup = function (env){
    var jsSdkScriptId = "epjs-js-snippet";
    var headNode = document.getElementsByTagName("head")[0];
    if (!document.getElementById(jsSdkScriptId)) {
      var jsSdkScript = document.createElement("script");
      jsSdkScript.innerHTML = '	if(window.BreadPayments=window.BreadPayments||{snippetVersion:"1.3.1"},!BreadPayments.init){var b=BreadPayments;b.on=function(){var t=["on"].concat(Array.prototype.slice.call(arguments));(b.q=b.q||[]).push(t)},b.submitRtps=function(){var t=["submitRtps"].concat(Array.prototype.slice.call(arguments));(b.q=b.q||[]).push(t)},b.setup=function(){var t=["setup"].concat(Array.prototype.slice.call(arguments));(b.q=b.q||[]).push(t)},b.checkout=function(){var t=["checkout"].concat(Array.prototype.slice.call(arguments));(b.q=b.q||[]).push(t)},b.registerPlacements=function(){var t=["registerPlacements"].concat(Array.prototype.slice.call(arguments));(b.q=b.q||[]).push(t)}}' +
      'BreadPayments.setup({env:"'+env +'"})';
      headNode.appendChild(jsSdkScript);
    }
  };

  EdsTestUtilClass.prototype.insertJsSdk = function (scriptUrl, dataset) {
    var jsSdkScriptId = "epjs-js-sdk";
    var bodyNode = document.getElementsByTagName("body")[0];
    if (!document.getElementById(jsSdkScriptId)) {
      var jsSdkScript = document.createElement("script");
      jsSdkScript.src = "" + scriptUrl;
      jsSdkScript.id = jsSdkScriptId;
      jsSdkScript.async = true;
      for (var key in dataset) {
        jsSdkScript.dataset[key] = dataset[key];
      }
      bodyNode.appendChild(jsSdkScript);
    }
  };
  EdsTestUtilClass.prototype.getSearchStr = function () {
    return location.search;
  };
  EdsTestUtilClass.prototype.getParameterByName = function (name, url) {
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)");
    var results = regex.exec(url);
    if (!results)
      return undefined;
    if (!results[2])
      return "";
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  };
  EdsTestUtilClass.prototype.getSDKConfig = function (sdkVersion, env, apiKey) {
    if (sdkVersion === void 0) { sdkVersion = 'BREAD'; }
    if (env === void 0) { env = 'PROD'; }
    if (apiKey === void 0) { apiKey = '7d9baa85-c938-43f1-ac44-07dfba689b23'; }
    sdkVersion = sdkVersion.toUpperCase();
    env = env.toUpperCase();
    var config = {
      sdkVersion: sdkVersion,
      env: env,
      apiKey: apiKey
    };
    switch (sdkVersion + "-" + env) {
      case 'BREAD-PROD':
        config.src = 'https://connect.breadpayments.com/unified.sdk.js';
        config.dataset = {
          breadMerchantKey: apiKey
        };
        break;
      case 'BREAD-STAGE':
        config.src = 'https://connect-preview.breadpayments.com/unified.sdk.js';
        config.dataset = {
          breadMerchantKey: apiKey
        };
        break;
      case 'BREAD-QA':
        config.src = 'https://checkout.npp-qa-ads.ue2.breadgateway.net/unified.sdk.js';
        config.dataset = {
          breadMerchantKey: apiKey
        };
        break;
      case 'AZ-STAGE':
        config.src = 'https://brand-sdk-az.adcsep.com/unified/unified.sdk.js';
        config.dataset = {
          breadMerchantKey: apiKey
        };
        break;
      case 'AZ-PROD':
        config.src = 'https://brand-sdk.kmsmep.com/unified/unified.sdk.js';
        config.dataset = {
          breadMerchantKey: apiKey
        };
        break;
    }
    return config;
  };
  EdsTestUtilClass.prototype.saveConfig = function (config) {
    var jsonConfig = JSON.stringify(config);
    window.sessionStorage.setItem('eds_test_config', jsonConfig);
  };
  EdsTestUtilClass.prototype.getSessionConfig = function () {
    var jsonConfig = window.sessionStorage.getItem('eds_test_config');
    return JSON.parse(jsonConfig);
  };
  EdsTestUtilClass.prototype.callSetup = function (){
    BreadPayments.setup({env:this.getSessionConfig().env});
  }
  EdsTestUtilClass.prototype.main = function () {
    var curConfig = this.getSessionConfig() || {};
    var url = this.getSearchStr();
    var sdkVersion = this.getParameterByName('sdk', url) || curConfig.sdkVersion;
    var sdkEnv = this.getParameterByName('env', url) || curConfig.env;
    var apiKey = this.getParameterByName('apiKey', url) || curConfig.apiKey;
    var config = this.getSDKConfig(sdkVersion, sdkEnv, apiKey);
    this.saveConfig(config);
    //this.insertJsSnippetWithSetup(config.env);
    this.insertJsSdk(config.src, config.dataset);
  };
  return EdsTestUtilClass;
}());
var EdsTestUtil = new EdsTestUtilClass();
EdsTestUtil.main();
